import { createStore } from "satcheljs";
import "../orchestrators";
import { IGoogleAdSenseViewState } from "./schema/IGoogleAdSenseViewState";

export const getGoogleAdSenseStore = createStore<IGoogleAdSenseViewState>('IGoogleAdSenseViewState', {
  active: {}
});